import { render, staticRenderFns } from "./AppendixClientPeople.vue?vue&type=template&id=4569dca6"
import script from "./AppendixClientPeople.vue?vue&type=script&lang=js"
export * from "./AppendixClientPeople.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports